export function getFleetSprite(imageUri = 'sprite://1'): string {
  return imageUri.replace('sprite://', '');
}
